export default {
  minValue (min) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '' && !Number.isNaN(value * 1.0)) {
        if (value * 1.0 < min) {
          callback(new Error(`值不能小于${min}`))
        }
      }
      callback()
    }
  }
}
